/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CSwitch,
  CCollapse,
  CRow,
} from '@coreui/react';

import API from 'src/utils/apiCalling';
import { config } from 'src/utils/apiUrl';
import BgvAuthorizationConsent from './other/bgv_authorization_consent';
import { toast, ToastContainer } from 'react-toastify';
import { getLocalDataAsObject } from 'src/utils/CoustomStorage';
import { useHistory } from 'react-router'
import { Cookies } from 'react-cookie';

const PolicyDetails = props => {
  const history=useHistory()
  const api = new API();
  const { getEmployeeDetailStatus, empStatus, empDetails } = props;
  const [accordion, setAccordion] = useState(0);
  const [policy1, setPolicy1] = useState(false);
  const [policy2, setPolicy2] = useState(false);
  const [policy3, setPolicy3] = useState(false);
  const [policy4, setPolicy4] = useState(false);
  const [policy5, setPolicy5] = useState(false);
  const [policy6, setPolicy6] = useState(false);
  const [policy7, setPolicy7] = useState(false);
  const [policy8, setPolicy8] = useState(false);
  const [policy9, setPolicy9] = useState(false);
  const [policy10, setPolicy10] = useState(false);
  const [policy11, setPolicy11] = useState(false);
  const [policy12, setPolicy12] = useState(false);
  const [policy13, setPolicy13] = useState(false);
  const [policy14, setPolicy14] = useState(false);
  const [policy15, setPolicy15] = useState(false);
  const [policy16, setPolicy16] = useState(false);
  const [policy17, setPolicy17] = useState(false);
  const [policy18, setPolicy18] = useState(false);
  const [policy19, setPolicy19] = useState(false);
  const [isDisabledBtn, setIsDisabledBtn] = useState(false);
  const [allPolicyAccept, setAllPolicyAccept] = useState(true);
  const [userSign, setUserSign] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [policyData, setPolicyData] = useState('');
  const [userID, setUserID] = useState('');
  const [joiningDate, setJoiningDate] = useState('');

  useEffect(() => {
    let userData = getLocalDataAsObject('user');
    if (userData && userData.length > 0) {
      setUserEmail(userData[0].email);
      setUserID(userData[0].id);
    }
  }, []);
    const Policyaccepted = async () => {
    if (!userSign) {
      toast.warning('Please sign');
      return;
    }
    let data = {};
    if (empDetails && empDetails.id) {
      data = {
        empPolicyAccept: allPolicyAccept,
        user_id: empDetails && empDetails.id,
        sign: userSign,
      };
    } else {
      data = {
        empPolicyAccept: allPolicyAccept,
        sign: userSign,
      };
    }

    let result = await api.post(config.employeePolicy, data);
    if (result && result.code === 200) {
      toast.success(result && result.message)
      getEmployeeDetailStatus();
        window.location.href = '/#/';
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
        Cookies.remove('token');
        Cookies.remove('user');

    } else {
      toast.error(result && result.message);
    }
  };

  const dataForPolicy = async () => {
    let data = {
      emp_user_id: empDetails?.id ? empDetails?.id : userID,
    };
    let result = await api.get(config.allDataforPolicy, true, data);
    if (result && result.code === 200) {
      setPolicyData(result.data[0]);
      setJoiningDate(result?.data?.[0]?.joining_date || moment().format('YYYY-MM-DD'));
    } else {
      toast.error(result && result.message)
      // alert(result && result.message);
    }
  };
  useEffect(() => {
    dataForPolicy();
  }, [userID, empDetails]);

  const acceptpolicy = (e, id) => {
    switch (id) {
      case 1:
        setPolicy1(!policy1);
        break;
      case 2:
        setPolicy2(!policy2);
        break;
      case 3:
        setPolicy3(!policy3);
        break;
      case 4:
        setPolicy4(!policy4);
        break;
      case 5:
        setPolicy5(!policy5);
        break;
      case 6:
        setPolicy6(!policy6);
        break;
      case 7:
        setPolicy7(!policy7);
        break;
      case 8:
        setPolicy8(!policy8);
        break;
      case 9:
        setPolicy9(!policy9);
        break;
      case 10:
        setPolicy10(!policy10);
        break;
      case 11:
        setPolicy11(!policy11);
        break;
      case 12:
        setPolicy12(!policy12);
        break;
      case 13:
        setPolicy13(!policy13);
        break;
      case 14:
        setPolicy14(!policy14);
        break;
      case 15:
        setPolicy15(!policy15);
        break;
      case 16:
        setPolicy16(!policy16);
        break;
      case 17:
        setPolicy17(!policy17);
        break;
      case 18:
        setPolicy18(!policy18);
        break;
        case 19:
        setPolicy19(!policy19);
        break;
      default:
      // console.log("something went wrong")
    }
    // isAllPolicyAccept()
  };

  const getSignFun = sign => {
    setUserSign(sign);
      };
  const sendOtp = async () => {
    let data = {
      email: userEmail,
      type: 'other',
      subject: 'OTP Verification for Policy',
    };
    let result = await api.post(config.sendOtp, data);
    // console.log("Result>>>>>>>>>", result)
    if (result && result.code === 200) {
      toast.success(result.message)
      // alert(result.message);
      setIsOtpSent(true);
    } else {
      toast.error(result && result.message)
      // alert(result && result.message);
    }
  };
  const verifyOTP = async () => {
    let data = {
      email: userEmail,
      otp: otp,
    };
    let result = await api.post(config.verifyOtp, data);
    if (result && result.code === 200) {
      toast.success(result.message)
      // alert(result.message);
      setIsVerified(true);
      // Policyaccepted();
    } else {
      toast.error(result && result.message)
      // alert(result && result.message);
    }
  };

  return (
    <CRow>
      <CCol xl="12">
        {true && (
          <CCard>
            <div className="text-center">
              <strong>Company Policies</strong>
              <br />
              <small>
                {' '}
                Kindly read all the policies by clicking respective one's
              </small>
            </div>

            <CCardBody>
              <div id="accordion">
                <CCard className="mb-0">
                  <CCardHeader id="headingOne">
                    <CButton
                      block
                      color=""
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 0 ? null : 0)}
                    >
                      <h5 className="m-0 p-0 text-black">
                      Intellectual Property Right
                        <i
                          className={
                            accordion === 0
                              ? 'fa fa-angle-double-up fa-lg text-black'
                              : 'fa fa-angle-double-down fa-lg text-black'
                          }
                          style={{ float: 'right' }}
                        ></i>
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 0}>
                    <CCardBody>
                    If during the period of your employment with us you achieve any invention, process improvement, operational improvement, or another process/method likely to result in the more efficient operation of any of the activities of the company, the company shall be entitled to use, utilize and exploit such improvement and you shall assign all rights thereof to the company for the purpose of seeking any patent rights or for any other purpose. The company shall have the sole ownership rights of all the intellectual property rights that you may create during the tenure of association with the company including but not limited to the creative concept that you may develop during your association with the company.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 1)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 1 ? null : 1)}
                    >
                      <h5 className="m-0 p-0 ">
                        Salary Policy{' '}
                        <i
                          className={
                            accordion === 1
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 1}>
                    <CCardBody>
                      <ul>
                        <li style={{ listStyleType: 'disc' }}>
                      <b style={{color:"#f54694"}}><u>Payment of Salary:</u></b> The salary of employees will become due and payable on the 5th of every month.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                      <b style={{color:"#f54694"}}><u>Deduction of Salary:</u></b> Deductions in salary may be made for coming late to work, unauthorized absence, fines imposed, etc. 
                        </li>
                      </ul>{' '}
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 2)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingThree">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 2 ? null : 2)}
                    >
                      <h5 className="m-0 p-0 ">
                      Personal Particulars{' '}
                        <i
                          className={
                            accordion === 2
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 2}>
                    <CCardBody>
                    You will keep us informed of any change in your residential address, family status or any other relevant particulars. You would also let us know the name and address of your legal heir/nominee.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 3)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingFour">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 3 ? null : 3)}
                    >
                      <h5 className="m-0 p-0 ">
                        Information Confidentiality{' '}
                        <i
                          className={
                            accordion === 3
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 3}>
                    <CCardBody>
                      <ul>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Access to Information:</u></b> Information is available on a need-to-know basis for specific groups and the network file server of the company is segregated to allow individual sectors information access for projects and units. Access to this is authorized through access privileges approved by unit mentors or project mentors.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Restriction on Personal Use:</u></b> The use of company resources for personal use is strictly restricted. This includes using computer resources, information, internet service, and working time of the company for any personal use.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Secrecy/Confidentiality:</u></b> You will not during the course of your employment with the company or at any time thereafter divulge or disclose to any person whomsoever, make any use whatsoever for your own purpose or for any other purpose other than that of the company, of any information or knowledge obtained by you during your employment related to Business Information, Customer Information, Product/Service/Code of Information, Employment Information. You further understand that in the event of your breaching this confidentiality undertaking, the company shall be free to initiate and take appropriate steps, as it may be advised, at your costs and expenses.
                        </li>
                      </ul>{' '}
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 4)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 4 ? null : 4)}
                    >
                      <h5 className="m-0 p-0 ">
                        Company’s Assets/ Email{' '}
                        <i
                          className={
                            accordion === 4
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 4}>
                    <CCardBody>
                      <ul>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Desktop PC/ Laptop Allotment:</u></b> This allotment is done based on the nature of the job of an employee and needs to be approved by the departmental head. 
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Email Facility:</u></b> On joining, you will be issued an email ID configured as name@acchho.com. Employees are only supposed to use an official email ID for all purposes. Using any other personal email ID (Gmail, Yahoo, etc.) during office hours and from official systems without approval is strictly not allowed.
                        </li>
                      </ul>
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 5)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 5 ? null : 5)}
                    >
                      <h5 className="m-0 p-0 ">
                        Training Policy{' '}
                        <i
                          className={
                            accordion === 5
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 5}>
                    <CCardBody>
                      <ul>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Training:</u></b> You will hold yourself in readiness for any training at any place whenever required. Kindly note that refusal to participate in a training program without any extraneous circumstances would lead to the automatic termination of your employment.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Importance of Training:</u></b> The company will provide you with extensive training during the first year of your employment with us and expects you to return the investment made on this training in the form of personal value addition to the company. The training materials provided to you are the property of the company and confidential information. Carrying the materials outside the company or disclosing them to anyone other than employees of the company is a breach of trust and will result in immediate forfeiture of the holding amount and termination of employment without notice.
                        </li>
                      </ul>
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 6)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 6 ? null : 6)}
                    >
                      <h5 className="m-0 p-0 ">
                        Workplace Policy{' '}
                        <i
                          className={
                            accordion === 6
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 6}>
                    <CCardBody>
                      <ul>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Violence at Workplace:</u></b> The company supports the philosophy that violence has no place in the workplace and that preventing potential workplace violence is a responsibility shared by all employees. You are responsible to meet the company standards, and norms of professionalism and demonstrating courtesy to colleagues, karigar and helpers. Spreading rumors, soliciting employees of the company for outside employment or coercing coworkers to leave the company is strictly prohibited and frowned upon. Such actions will immediately terminate employment without notice and forfeiture of your holding amount. 
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Smoking/ Alcohol and Drug Abuse at Workplace:</u></b> Keeping in mind the safety of the office premises and the comfort of colleagues, you must abstain from smoking in office premises. Consumption of alcoholic beverages or drugs is strictly prohibited. Employees found to have violated these policies will be subjected to appropriate disciplinary action.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Posting of Product/ Office/ Workshop Pictures:</u></b> Employees are not allowed to post or publish any pictures of the product, office, or workshop premises anywhere on social media like Facebook, Instagram, etc. without prior approval from the company. 
                        </li>
                      </ul>
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 7)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 7 ? null : 7)}
                    >
                      <h5 className="m-0 p-0 ">
                        Sexual Harassment{' '}
                        <i
                          className={
                            accordion === 7
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 7}>
                    <CCardBody>
                    Gryphon Academy aims at creating a work environment where the safety and dignity of women employees are ensured and they are protected from Sexual Harassment under “The Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013. This Policy intends to ensure that no woman Employee is subjected to sexual harassment and it is applicable to all Employees of Gryphon Academy and its fraternity. <br/>
                    <b>The company provide certain ways for reporting complaint:</b>
                      <ul>
                        <li style={{ listStyleType: 'disc' }}>
                        The employee can discuss the issue with the reporting manager or HR.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        If the particular issue is not resolved, then the aggrieved woman can reach the Managing Director and narrate the whole incident. The MD will attempt to resolve the issue within the stipulated time. 
                        </li>{' '}
                      </ul>
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 8)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 8 ? null : 8)}
                    >
                      <h5 className="m-0 p-0 ">
                      Grievance Management{' '}
                        <i
                          className={
                            accordion === 8
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 8}>
                    <CCardBody>
                    Individual employee grievances and complaints which are primarily a manifestation of their dissatisfaction with working conditions, and managerial decisions, if not 
promptly attended to may affect morale and productivity. The aggrieved employee may raise the grievance to the reporting manager or HR.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 9)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 9 ? null : 9)}
                    >
                      <h5 className="m-0 p-0 ">
                      Standing Orders{' '}
                        <i
                          className={
                            accordion === 9
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 9}>
                    <CCardBody>
                    You will abide by the Standing Orders, rules & regulations and service conditions that may be in force or application to the organization or are framed from time to time by the company.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 10)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 10 ? null : 10)}
                    >
                      <h5 className="m-0 p-0 ">
                      Attendance Policy{' '}
                        <i
                          className={
                            accordion === 10
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 10}>
                    <CCardBody>
                    <ul>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}>Working Hours:</b> Monday to Saturday from 9:30 AM to 6:30 PM. The Company reserves the right to change your working days and hours. After completing the probationary period, the standard working schedule will be five days a week.
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}>Late Coming/ Early Going: </b>
                        <ul>
                        <li style={{ listStyleType: 'diamond' }}>
                        <b><u>Late Coming:</u></b> If an employee punches after 9:45 AM for more than 3 days in a month then his/her half-day salary is deducted. If an employee punches after 10:30 AM, then half day is deducted.
                        </li>
                        <li style={{ listStyleType: 'diamond' }}>
                        <b><u>Early Going:</u></b> If an employee punches out before 6:15 PM more than 3 times in a month then his/her half-day salary is deducted.
                        </li>
                        <li style={{ listStyleType: 'diamond' }}>
                        <b><u>Half Day:</u></b> Half Day going time is 2:00 PM. Half Day coming time is 2:00 PM. 
                        </li>
                        </ul>
                        </li>
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}>Lunch Timings:</b> 1 PM to 1:45 PM. Employees are expected to respect the lunch timings in both cases if they plan to have lunch in the office or outside. If you leave the office for lunch, make sure you are back within 45 minutes. Try and leave for lunch in time to be back in time.
                        </li>
                      </ul>
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 11)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 11 ? null : 11)}
                    >
                      <h5 className="m-0 p-0 ">
                        Grooming & Dress-Code Policy{' '}
                        <i
                          className={
                            accordion === 11
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 11}>
                    <CCardBody>
                    All employees shall practice good personal hygiene, select attire that is clean and in good condition and must present a professional image at work. 
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 12)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 12 ? null : 12)}
                    >
                      <h5 className="m-0 p-0 ">
                       Nature of Work{' '}
                        <i
                          className={
                            accordion === 12
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 12}>
                    <CCardBody>
                  You will work at a high standard of initiative, creativity, efficiency and economy in the organization. The nature of work and responsibilities will be assigned and explained to you by your seniors from time to time.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 13)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 13 ? null : 13)}
                    >
                      <h5 className="m-0 p-0 ">
                      Assignment, Transfer and Deputation
                        <i
                          className={
                            accordion === 13
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 13}>
                    <CCardBody>
                  Though you have been engaged in a specific position, the company reserves the right to send you on deputation/transfer/assignment to any of the company's branch offices in India or abroad, whether existing at the time of your appointment or to be set up in the future.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 14)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 14 ? null : 14)}
                    >
                      <h5 className="m-0 p-0 ">
                        Confirmation Process{' '}
                        <i
                          className={
                            accordion === 14
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 14}>
                    <CCardBody>
                    You are required to serve a probationary period of 6 months after which your service will be confirmed as a regular employee only after confirmation of your employment in writing subject to satisfactory performance. The probationary period may be extended or shortened at the company’s absolute discretion. During the probationary period, the appointment may be terminated by the company giving with or without a notice period of 1 week. The Company can immediately terminate you from services without notice if you are found guilty of misconduct.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 15)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 15 ? null : 15)}
                    >
                      <h5 className="m-0 p-0 ">
                        Leave Policy{' '}
                        <i
                          className={
                            accordion === 15
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 15}>
                    <CCardBody>
                    Gryphon Academy recognizes the importance of providing a certain amount of flexibility to the employee so that they can take care of personal, domestic & Social necessities.
                      <br />
                      <ul>
                        {' '}
                        <li style={{ listStyleType: 'disc' }}>
                          {' '}
                        <b style={{color:"#f54694"}}><u>Company declared holidays:</u></b> Holidays will be given based on the company’s holiday calendar. {' '}
                        </li>{' '}
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Casual Leaves and Earned Leaves:</u></b> After the successful completion of 6 months of employment at Gryphon Academy, you will be entitled to a total of 1 Casual Paid leave per month and 7 additional earned leaves per year, i.e. 19 leaves per year. (Calculated and adjusted as per the financial year). These leaves can be carried forward and can be redeemed later in any month. The 7 earned leaves, if accumulated at the end of the financial year, will be en-cashed and added to your basic salary.  In case you are taking a 7-day leave in continuation due to any event, family commitment, etc., you need to give prior notice, at least 45 days before via a formal email. In case of emergency or sick leaves, please inform HR as the entitled paid leaves will be adjusted against such leaves after approval from HR.  For sick leaves of more than 2-3 days, HR may request you to present a doctor's prescription, etc.
                        </li>{' '}
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Sandwich Leaves:</u></b> If an employee takes leaves for more than 1 day and if there are any holiday(s) (Sunday or Public Holiday) falling between those days then the total number of leaves counted will include the holiday falling in between these leaves. For example: If you take a leave on Saturday and Monday, the total number of leaves counted will be 3.
                        </li>{' '}
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Maternity Leaves:</u></b> According to the Maternity Benefit Act, 2017, the pregnant employee is entitled to get 26 weeks of leave. However, a woman with already two or more children is entitled to 12 weeks of maternity leave. 
                        </li>{' '}
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Paternity Leaves:</u></b> According to Paternity Benefit Bill in 2017, male employees have the right to avail paternity leave of fifteen days.
                        </li>{' '}
                        <li style={{ listStyleType: 'disc' }}>
                        <b style={{color:"#f54694"}}><u>Miscarriage:</u></b>  In case of miscarriage, a woman shall, on the production of such proof as may be prescribed, be entitled to leave with wages at the rate of maternity benefit for six weeks immediately following the day of her miscarriage.
                        </li>{' '}
                      </ul>{' '}
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 16)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 16 ? null : 16)}
                    >
                      <h5 className="m-0 p-0 ">
                      Appointment in Good Faith{' '}
                        <i
                          className={
                            accordion === 16
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 16}>
                    <CCardBody>
                    It must be specifically understood that this offer is made based on your proficiency in technical professional skills you have declared to possess as per your application for employment and your ability to handle any assignment/job independently. In the case at a later date, any of your statement’s particulars furnished are found to be false or misleading or your performance is not up to the mark or falls short of the minimum standard set by the company, the company shall have the right to terminate your services forthwith without giving any notice notwithstanding any other terms and conditions stipulated therein. 
                    </CCardBody>
                      <CCardFooter>
                        I have thoroughly read the instruction and accepted the
                        policy.
                        <br />
                        {empStatus && empStatus.emp_policy_status !== 1 && (
                          <CSwitch
                            className={'mx-1'}
                            variant={'3d'}
                            color={'success'}
                            onChange={e => acceptpolicy(e, 17)}
                            labelOn={'\u2713'}
                            labelOff={'\u2715'}
                          />
                        )}
                      </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-0">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 17 ? null : 17)}
                    >
                      <h5 className="m-0 p-0 ">
                      Separation Policy
                        <i
                          className={
                            accordion === 17
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 17}>
                    <CCardBody>
                      <b>Gryphon Academy believes in treating all employees separated from the company with utmost dignity. </b>
                      <br/>
                      <ul>
                        <li style={{ listStyleType: 'diamond' }}>
                        <b style={{color:"#f54694"}}><u>Resignation:</u></b> Resignation means that an employee voluntarily leaves the company’s service for professional and personal reasons. All resignations must be confirmed in writing. It must include the reason for leaving and the effective date. The employee is required to serve 1 month of the notice period (even during the probation period). If he or she fails to do so then the employer has the rights to hold the salary accordingly. 
                      </li>
                      <li style={{ listStyleType: 'diamond' }}>
                        <b style={{color:"#f54694"}}><u>Termination:</u></b> The company holds the right to terminate the employee on grounds of his failure to perform or attendance sticking to. Unauthorized absence or absence without permission from duty for a continuous period of 3 days. 
                        <ul>
                          <li style={{ listStyleType: 'disc' }}>
                          Your appointment is being made based on your particulars as mentioned by you and in case any information given by you is found false or incorrect, your appointment will be deemed void and liable for termination, without any notice or salary instead of notice.
                          </li>
                          <li style={{ listStyleType: 'disc' }}>
                          Your appointment can be terminated by the management after giving one-month notice or an amount equal to one-month salary in lieu thereof.
                          </li>
                          <li style={{ listStyleType: 'disc' }}>
                          Gryphon Academy Jaipur holds the authority of immediate termination of employment with or without any notice under unacceptable reasons.
                          </li>
                          <li style={{ listStyleType: 'disc' }}>
                          The decision will be made by the management after having a one-to-one conversation with the employee.
                          </li>
                          </ul>
                      </li>
                      <li style={{ listStyleType: 'diamond' }}>
                      <b style={{color:"#f54694"}}><u>Exit Interview:</u></b> Before leaving the organization, an interview is conducted to gather feedback and recommendations from the outgoing employee. Exit Interview is a one-on-one discussion where voluntary views and suggestions are taken from the outgoing employee on what his/her expectations had been, about the experience while working with the company, etc. It ensures that all the company property, including keys, tools, mobile phones, company Sim, laptops and other equipment are returned to the organization. 
                      </li>
                      </ul>
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 18)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                </CCard>
                <CCard className="mb-5">
                  <CCardHeader id="headingTwo">
                    <CButton
                      block
                      color="link"
                      className="text-left m-0 p-0"
                      onClick={() => setAccordion(accordion === 18 ? null : 18)}
                    >
                      <h5 className="m-0 p-0 ">
                      Full & Final Settlement{' '}
                        <i
                          className={
                            accordion === 18
                              ? 'fa fa-angle-double-up fa-lg '
                              : 'fa fa-angle-double-down fa-lg '
                          }
                          style={{ float: 'right' }}
                        ></i>{' '}
                      </h5>
                    </CButton>
                  </CCardHeader>
                  <CCollapse show={accordion === 18}>
                    <CCardBody>
                    The F&F consists of clearances from various departments such as admin, IT, finance, HR, and of course the department, to which the employee belongs to. The employee must return all the company assets – laptop, mobile, computer, or any other thing - in their possession.  The company may deduct money for any damage in the F&F settlement. The full & final amount, the relieving letter and the experience letter will be given to the employee within two working days of his/her removal, dismissal, or resignation.
                    </CCardBody>
                    <CCardFooter>
                      I have thoroughly read the instruction and accepted the
                      policy.
                      <br />
                      {empStatus && empStatus.emp_policy_status !== 1 && (
                        <CSwitch
                          className={'mx-1'}
                          variant={'3d'}
                          color={'success'}
                          onChange={e => acceptpolicy(e, 19)}
                          labelOn={'\u2713'}
                          labelOff={'\u2715'}
                        />
                      )}
                    </CCardFooter>
                  </CCollapse>
                  </CCard>
                <BgvAuthorizationConsent
                  getSignFun={getSignFun}
                  empDetails={empDetails}
                  policyData={policyData}
                  setIsDisabledBtn ={setIsDisabledBtn}
                />
              </div>
              <br />
            </CCardBody>
            <CCardFooter>
                  {/* {!isOtpSent &&
                    empStatus &&
                    empStatus.emp_policy_status !== 1 && (
                      <button
                        type="button"
                        disabled={
                          policy1 & policy2 & policy3 & policy4 &&
                            policy5 &
                            policy6 &
                            policy7 &
                            policy8 &
                            policy9 &
                            policy10 &
                            policy11 &
                            policy12 &
                            policy13 &
                            policy14 &
                            policy15 &
                            policy16 &
                            policy17 &
                            policy18&
                            policy19
                            ? false
                            : true
                        }
                        onClick={sendOtp}
                        className="btn btn-primary mr-3 mt-2 float-right"
                      >
                        Verify
                      </button>
                    )} */}
                 
                  {empStatus && empStatus.emp_policy_status !== 1 && (
                    <>
                      <div className="row">
                        {/* <div className="col-md-3">
                          <input
                            type="text"
                            className="form-control"
                            value={otp}
                            onChange={e => setOtp(e.target.value)}
                            placeholder="Enter Otp"
                          />
                        </div> */}
                                                <div className="col-md-12">
                            <button
                              type="button"
                              disabled={
                                policy1 & policy2 & policy3 & policy4 &&
                                  policy5 &
                                  policy6 &
                                  policy7 &
                                  policy8 &
                                  policy9 &
                                  policy10 &
                                  policy11 &
                                  policy12 &
                                  policy13 &
                                  policy14 &
                                  policy15 &
                                  policy16 &
                                  policy17 &
                                  policy18&
                                  policy19 & isDisabledBtn
                                  ? false
                                  : true
                              }
                              onClick={Policyaccepted}
                              className="btn btn-primary float-right"
                            >
                              Submit
                            </button>
                            
                        </div>
                      </div>
                    </>
                  )}
            </CCardFooter>
          </CCard>
        )}
      </CCol>
      <ToastContainer />
    </CRow>
  );
};
export default PolicyDetails;
